import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.links && _vm.links.length)?_c('follow-artist-card',_vm._l((_vm.links),function(link,index){return _c('div',{key:index,staticClass:"linkarea"},[(link.description)?_c('p',[_vm._v(_vm._s(link.description))]):_vm._e(),_c(VBtn,{staticClass:"mt-3",attrs:{"large":"","color":'rgba(255,255,255,0.4)'},on:{"click":function($event){return _vm.goToLink(link.url)}}},[_vm._v(_vm._s(link.text))])],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }